module.exports = __webpack_public_path__ + "media/images/countrysquared/sv-85597f32b59157e7de07bfa6f3d08e6e.svg";